export default __webpack_public_path__ + "static/media/dashboard.e526706e.png";